var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ palette }) => ({
    label: {
        wordBreak: 'break-word',
        color: palette.primary.contrastText,
        borderColor: palette.primary.contrastText,
    },
}));
const CookiesButton = (_a) => {
    var { className, href } = _a, rest = __rest(_a, ["className", "href"]);
    const classes = useStyles();
    return (React.createElement(Button, Object.assign({ className: className ? `${className} ${classes.label}` : classes.label, href: href, role: href ? 'link' : 'button', size: "small", variant: "outlined" }, rest)));
};
CookiesButton.displayName = 'CookiesBanner.Button';
const CookiesButtonExtra = styled(CookiesButton) ``;
export default CookiesButtonExtra;
